export const REQUEST_PROFILE = "REQUEST_PROFILE";
export const RECEIVE_PROFILE = "RECEIVE_PROFILE";
export const INVALIDATE_PROFILE = "INVALIDATE_PROFILE";
export const LOGOUT_USER = "LOGOUT_USER";
export const APPLY_AUTH = "APPLY_AUTH";
export const SET_GUEST_USER = "SET_GUEST_USER";
export const ADD_TAGS = "ADD_TAGS";

export function requestProfile() {
  return {
    type: REQUEST_PROFILE
  };
}

export function receiveProfile(result) {
  return {
    type: RECEIVE_PROFILE,
    result
  };
}

export function invalidateProfile() {
  return {
    type: INVALIDATE_PROFILE
  };
}

export function logoutUser() {
  return {
    type: LOGOUT_USER
  };
}

export function applyAuth(formResult) {
  return {
    type: APPLY_AUTH,
    formResult,
  };
}

export function setGuestUser() {
  return {
    type: SET_GUEST_USER
  };
}

export function addTags(tags) {
  return {
    type: ADD_TAGS,
    tags,
  }
}
